import { render, staticRenderFns } from "./DealFilterDesktop.vue?vue&type=template&id=24a54f2e"
import script from "./DealFilterDesktop.vue?vue&type=script&lang=js"
export * from "./DealFilterDesktop.vue?vue&type=script&lang=js"
import style0 from "./DealFilterDesktop.vue?vue&type=style&index=0&id=24a54f2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports